import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { driver } from "driver.js";
import { GuiService } from 'src/app/services/gui.service';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'vex-nutrition-user',
  templateUrl: './nutrition-user.component.html',
  styleUrls: ['./nutrition-user.component.scss']
})
export class NutritionUserComponent implements OnInit {

  constructor(public guiService: GuiService, public translate: TranslateService, public router: Router, public dialog: MatDialog) { }

  ngOnInit() {
    this.guiService.showSpinner = false;
    setTimeout(() => {
      localStorage.getItem('tourNutritionShowed') ? null : this.startTour();
    }, 1000);
    if (!this.guiService.userLogged){
      this.guiService.goTo('main/home');
    }
  }

  calcNextQuestionnaire(){
    const lastSurveyDate = moment(this.guiService.userLogged.masterData.lastSurvey);
    const endDate = lastSurveyDate.add(30, 'days');
    return endDate.diff(moment(), 'days');
  }

  compileSurvey(){
    let param;
    param = this.guiService.userLogged.masterData.lastDietUploaded ? 'follow-up' : 'questionnaire';
    this.router.navigate(['main/compile-survey'], {
      queryParams: { surveyType: param}
    });
  }

  getDiet(){
    const param = this.guiService.userLogged.masterData.lastSurveyWithDietUploadedId;
    this.router.navigate(['main/meal-plan'], {
      queryParams: { dietId: param}
    });
  }

  discover(){
    if(this.translate.currentLang == 'it'){
      this.guiService.goToExternalLink('https://itsdesifit.com/it/piano-diamond/');
    }else{
      this.guiService.goToExternalLink('https://itsdesifit.com/diamond-plan/');
    }
  }

  infos(){
    if(this.translate.currentLang == 'it'){
      this.guiService.goToExternalLink('https://itsdesifit.com/it/informazioni-aggiuntive-piano-diamond/');
    }else{
      this.guiService.goToExternalLink('https://itsdesifit.com/additional-information-diamond-plan/');
    }
  }

  async presentModalPdf(param) {
    let link = document.createElement('a');
    link.setAttribute('type', 'hidden');
    if(param == 1){
      link.href = "assets/44pdf44/44cucina_"+this.translate.currentLang+'.pdf';
      if(this.translate.currentLang == 'it'){
        link.download = 'In cucina con itsDesifit';
      }else{
        link.download = 'In the kitchen with itsDesifit';
      }
    }else if(param == 2){
      link.href = "assets/44pdf44/44guida_"+this.translate.currentLang+'.pdf'
      if(this.translate.currentLang == 'it'){
        link.download = 'Guida Nutrizionale';
      }else{
        link.download = 'Nutritional Guide';
      }
    }
    document.body.appendChild(link);
    link.click();
    link.remove();

  }

  startTour(): void {
    localStorage.setItem('tourNutritionShowed', 'true');
    const steps: any = [
        { element: '.nutrition-guide-container', popover: { title: this.translate.instant('TUTORIALS.nutrition.exploreEbooksTitle'), description: this.translate.instant('TUTORIALS.nutrition.exploreEbooksDescription'), side: 'bottom' } },
        { element: '.survey-box', popover: { title: this.translate.instant('TUTORIALS.nutrition.fillQuestionnaireTitle'), description: this.translate.instant('TUTORIALS.nutrition.fillQuestionnaireDescription'), side: 'bottom' } },
        { element: '.meal-box', popover: { title: this.translate.instant('TUTORIALS.nutrition.receiveMealPlanTitle'), description: this.translate.instant('TUTORIALS.nutrition.receiveMealPlanDescription') } }
    ];
    this.guiService?.userLogged?.userPaymentInfo?.subscriptionType ==='GOLD' ? steps.splice(-2) : null;

    const driverObj = driver({
      showProgress: true,
      allowClose: true,
      steps
    });

    driverObj.drive();
  }
}

